var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTime(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "time",
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_21026",
    "data-name": "Path 21026",
    d: "M8,14a6,6,0,1,1,6-6A6,6,0,0,1,8,14ZM8,2.857A5.143,5.143,0,1,0,13.143,8,5.143,5.143,0,0,0,8,2.857Z",
    transform: "translate(-2 -2)",
    fill: "#666"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_21027",
    "data-name": "Path 21027",
    d: "M17.4,13.429l-2.4-2.4V7h.857v3.677L18,12.824Z",
    transform: "translate(-9.429 -4.857)",
    fill: "#666"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTime);
export default __webpack_public_path__ + "static/media/time.476e49307b83291b6bb23356ae93b908.svg";
export { ForwardRef as ReactComponent };